import React from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Box, Typography, Paper, CircularProgress } from '@mui/material'
import { useSensorLocations } from '../layers/sensor_locations'
import SensorList from '../components/list/SensorList'
import type { GeoJsonFeature } from '../utils/ogc'
import NavBar from '../components/menu/NavBar'

export const Route = createFileRoute('/sensors')({
  component: SensorsPage,
})

export default function SensorsPage() {
  const { features, loading } = useSensorLocations()

  return (
    <>
    <NavBar />
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default', p: { xs: 2, md: 4 } }}>
      <Box sx={{ maxWidth: 1200, mx: 'auto', display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Box>
          <Typography variant="h3" sx={{ fontWeight: 900, mb: 1 }}>
            FloodNet Sensors List
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Deployment status, location, and recent measurement time for every sensor.
          </Typography>
        </Box>
        <Paper variant="outlined" sx={{ width: '100%', overflow: 'hidden' }}>
          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
              <CircularProgress size={24} />
            </Box>
          ) : (
            <SensorList
              features={(features || []) as any}
              currentTime={undefined}
              highlightedKey={null}
            />
          )}
        </Paper>
      </Box>
    </Box>
    </>
  )
}
